import axios from 'axios';


if (typeof process.env.VUE_APP_HTHC_API === 'undefined') {
  console.error('Required environment variable "VUE_APP_HTHC_API" is not defined.');
}

const state = () => ({
  apiUrl: process.env.VUE_APP_HTHC_API,
});

const getters = {};

const mutations = {};

const actions = {
  // api requests can be called from other stores and in components from these functions
  apiRequest(context) {},
  // a protected api requests requires an idToken from AWS cognito and can be used to query user/private info
  async protectedApiRequest(context, params) {
    try {
      const session = await context.dispatch('getCurrentUserSession');
      if (!session) {
        console.log('No session: could not retrieve session.');
        // probably redirect to login or let user know to login
        return;
      }

      const url = context.state.apiUrl + params.route;
      let body = null;
      const options = {
        headers: {
          'Access-Control-Allow-Methods': 'GET, PUT,POST, DELETE, HEAD, OPTIONS',
          Authorization: session.idToken.jwtToken,
        },
      };

      if (params.type === 'GET') {
        const response = await axios.get(url, options);
        return response;
      } else if (params.type === 'POST') {
        try {
          body = params.body;
        } catch (error) {
          console.log('No "body" when request body is expected.');
        }
        const response = await axios.post(url, body, options);
        return response;
      } else if (params.type === 'PUT') {
        try {
          body = params.body;
        } catch (error) {
          console.log('No "body" when request body is expected.');
        }
        const response = await axios.put(url, body, options);
        return response;
      } else if (params.type === 'DELETE') {
        const response = await axios.delete(url, options);
        return response;
      }
    } catch (error) {
      console.warn(error);
    }
  },
};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
